module.exports = __webpack_public_path__ + "b4048e97d0968c9774d28f0596de6c1f.svg";